import { baseApi } from '@/rtkQuery/features/services/baseApi';
import { CONTACT_US_ENDPOINTS } from '@/rtkQuery/config/contactUsApi.config';
import type { ContactFormRequest, ContactFormResponse } from '@/rtkQuery/features/models/contactUs.model';

export const contactUsApi = baseApi.injectEndpoints({
    endpoints: (builder) => ({
        submitContactForm: builder.mutation<ContactFormResponse, ContactFormRequest>({
            query: (payload) => ({
                url: CONTACT_US_ENDPOINTS.SUBMIT,
                method: 'POST',
                body: payload,
            }),
            transformResponse: (response: ContactFormResponse, meta) => {
                (meta as any).status = 'success';
                (meta as any).error = null;
                return response;
            },
            transformErrorResponse: (response: any, meta) => {
                const errorMessage = response.data?.message || 'Failed to submit contact form';
                (meta as any).status = 'error';
                (meta as any).error = errorMessage;

                return {
                    status: response.status,
                    message: errorMessage,
                    errors: response.data?.errors || {},
                };
            },
        }),
    }),
    overrideExisting: false,
});

export const { useSubmitContactFormMutation } = contactUsApi;
